import React, { Component } from "react";
import "./App.css";
/*eslint-disable no-unused-vars*/
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
/*eslint-enable no-unused-vars*/
import NavBar from "./components/navBar";
import ListQuestions from "./pages/listQuestions";
import Profile from "./pages/profile";
import ErrorPage from "./pages/404";
import Search from "./pages/search";
// import Feed from "./pages/feed";
import Lists from "./pages/lists";
import PresentationView from "./pages/presentation";

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <NavBar />
        <Switch>
          {/* <Route exact path="/" component={Lists} /> */}
          {/* <Route exact path="/search" component={Search} /> */}
          {/* <Route exact path="/question" component={ListQuestions} />
          <Route path="/profile" component={Profile} /> */}

          <Route path="*" component={PresentationView} />
        </Switch>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js